import { z } from 'zod';

const ReceptionVehicleTargetSchema = z.object({
  kind: z.literal('VEHICLE'),
  customerVehicleId: z.uuid(),
});

const ReceptionPartTargetSchema = z.object({
  kind: z.literal('PART'),
  partName: z.string().trim().min(1).max(300),
  parentPartId: z.uuid().nullable().optional(),
});

const ReceptionContainerTargetSchema = z.object({
  kind: z.literal('CONTAINER'),
  containerLabel: z.string().trim().min(1).max(200),
});

export const ReceptionTargetSchema = z.discriminatedUnion('kind', [
  ReceptionVehicleTargetSchema,
  ReceptionPartTargetSchema,
  ReceptionContainerTargetSchema,
]);

export const OpenReceptionBodySchema = z.object({
  partyId: z.uuid(),
  customerRoleId: z.uuid(),
  target: ReceptionTargetSchema,
  receptionMode: z.enum(['FULL', 'EXPRESS']).optional(),
  entryOdometerKm: z.number().int().nonnegative().nullable().optional(),
  reportedIssue: z.string().trim().max(2000).nullable().optional(),
  notes: z.string().trim().max(2000).nullable().optional(),
});

export type OpenReceptionBody = z.infer<typeof OpenReceptionBodySchema>;

export const OpenReceptionResponseSchema = z.object({
  receptionId: z.uuid(),
  quoteId: z.uuid(),
});

export type OpenReceptionResponse = z.infer<typeof OpenReceptionResponseSchema>;
